import { render, staticRenderFns } from "./InstitutionalManagement.vue?vue&type=template&id=a62b864a&scoped=true"
import script from "./InstitutionalManagement.vue?vue&type=script&lang=js"
export * from "./InstitutionalManagement.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalManagement.vue?vue&type=style&index=0&id=a62b864a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62b864a",
  null
  
)

export default component.exports